import React, { useEffect, useState } from 'react'
import { Row, Table } from 'react-bootstrap'
import { getFilesDetailsDocsAPI } from '../../../services/files'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../helper/check-user-admin'
import FileDocsTable from './file-docs-table'
import moment from 'moment'

export default function ProfileDocument() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [docsType, setDocsType] = useState([])

  useEffect(() => {
    if (orgId && code) {
      getFilesDetailsDocs()
    }
  }, [orgId, code])
  const getFilesDetailsDocs = async () => {
    const result = await getFilesDetailsDocsAPI({ orgId, code })
    if (!result) return
    const newData = result.result.map((d, i) => {
      return {
        value: d.id,
        label: d.document,
        isFile: d.isFile,
        insertDate: d.insert_date,
        mandatory: d.mandatory
      }
    })
    setDocsType(newData)
  }
  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)

  return (
    <Row>
      <p className="text-primary">Document</p>

      <Table>
        <thead
          className="bg-hrms text-white "
          style={{ position: 'sticky', top: '0px' }}
        >
          <tr className="font-title-table ">
            <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              #
            </th>
            <th style={{ whiteSpace: 'nowrap' }} className="fw-normal">
              Document
            </th>
            <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              Upload Date
            </th>
            <th
              style={{ whiteSpace: 'nowrap' }}
              className="fw-normal text-center"
            >
              <span className="fw-normal ">File </span>
              <span className="fw-light small ">(PDF Max 8 MB)</span>
            </th>
          </tr>
        </thead>

        <tbody>
          {' '}
          {docsType &&
            docsType.map((d, i) => (
              <>
                <FileDocsTable
                  keys={i}
                  typeId={d.value}
                  detail={d.label}
                  isFile={d.isFile}
                  insertDate={
                    d.insertDate
                      ? moment(d?.insertDate).format('DD/MM/YYYY')
                      : '-'
                  }
                  mandatory={d.mandatory}
                  idcode={{ orgId, code }}
                  fnData={getFilesDetailsDocs}
                  roles={roles}
                />
              </>
            ))}
        </tbody>
      </Table>
    </Row>
  )
}
